/** @module Auth0ClientEx */
/* eslint-disable import/extensions */
import Auth0Client from '../../utils/auth0-client-utils.mjs';


class Auth0ClientEx extends Auth0Client {
  // a version of Auth0Client that can use the MST renderer
  get isMobileApp() {
    return this._clientId === 'asDWgfdzraaKVBDxb69F5Zkmwvw5AvgP'
           || this._clientId === '1Frmpin38dvrCxqBYO3BgJikR1dn705c'
           || this._clientId === 'rXLAzNrZdcyMcWRJAWzuXvvMZHsuSMeI'
           || this._clientId === 'P0eAOqrACKBwhzoVKTgP76m7aYWijSYE';
  }

  get isIosApp() {
    return this._clientId === 'asDWgfdzraaKVBDxb69F5Zkmwvw5AvgP'
           || this._clientId === '1Frmpin38dvrCxqBYO3BgJikR1dn705c';
  }

  get isAndroidApp() {
    return this._clientId === 'rXLAzNrZdcyMcWRJAWzuXvvMZHsuSMeI'
           || this._clientId === 'P0eAOqrACKBwhzoVKTgP76m7aYWijSYE';
  }

  get isSsV3App() {
    return this._clientId === 'V5qSP9pbN31jHgA6A6JulXzhMFIFNIaH';
  }

  get isSsV2App() {
    return this._clientId === 'Jq27xZVkRCHuor3KkZH0J131CTkhsVBa';
  }

  get isSsApiApp() {
    return this._clientId === 'HK9mNchVFvmG6I26hYizhNldaftpIVy1';
  }

  get isSeApiApp() {
    return this._clientId === '5MVA09MeAPHrkhWeDs1D7X7T7N45Q6Wt';
  }

  get isConnectApp() {
    return this._clientId === 'he66BNO59fdC6EoUTFl1GerXSbvYEfJp';
  }
}

export default Auth0ClientEx;
